import { Login } from 'pages/common/Login/Login'
import MapLargeScreen from 'pages/functions/MapLargeScreen/MapLargeScreen'
import FVSList from 'pages/common/FVSList/FVSList'

import { Boundary } from 'components'
import { Routers } from './router'
import { useContextConsumer } from 'context/loginAuthProvider'
import zh from 'antd/lib/locale/zh_CN' // antd 国际化 - 中文语音包
import en from 'antd/lib/locale/en_US' // antd 国际化 - 英文语音包
import { ConfigProvider } from 'antd'
import { useDispatch } from 'react-redux' // redux
import { BrowserRouter } from 'react-router-dom'
import { MainLayout } from 'layouts'
// import { getNavDataList } from './components/Nav/NavData'
import { useEffect } from 'react'
import { NavSlice, getSystemInfoAction, getAuthLocationDataAction } from 'redux/reducers'
import { clearUrlTicket, getStroage, setStroage } from 'utils'
import { useTranslation } from 'react-i18next'
import Relay from 'pages/common/Relay/Relay'

export const App = () => {
    const { token, setToken } = useContextConsumer() // 登录权鉴
    const language = getStroage('language')
    if (!language) setStroage('language', 'en')
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const pathname = window.location.pathname

    // 临时页面
    const largeScreenURL = pathname === '/megalinkMap'
    const fvsListURL = pathname === '/fvs_list' // 周计划列表
    const searchParams = new URLSearchParams(window.location.search)
    // 2. 提取 ticket 参数（参数名与 URL 中的保持一致，如 ?ticket=xxx）
    const ticket = searchParams.get('ticket') || ''

    window.scrollTo(0, 0) // 重置卷动值

    /* 监听路由变化，更改网页 title */
    useEffect(() => {
        window.addEventListener(
            'error',
            function (event) {
                if (
                    event.message &&
                    String(event.message).includes('chunk') &&
                    String(event.message).includes('failed')
                ) {
                    window.location.replace(window.location.href)
                }
            },
            true
        )
    })

    /* 统一设置网页 title */
    document.title = t('common.title')

    /* 获取 url token, 从海洋系统跳转过来 */
    const urlToken = new URLSearchParams(window.location.search).get('code')
    useEffect(() => {
        if (!urlToken) return
        window.history.pushState(null, '', window.location.origin) // 重置浏览器地址栏，不触发浏览器刷新
        setToken(urlToken) // 刷新 token
        setStroage('token', urlToken) // 本地存储 token
    }, [urlToken])

    /* 手动修改 url 处理 */
    useEffect(() => {
        if (!token) return
        let path = window.location.pathname
        const result = [...path.split('/')].pop()
        let result2 = path
        if (result === 'detail') {
            result2 = path.replace('/detail', '')
        }
        if (result === '') {
            result2 = path.slice(0, -1)
        }
        if (path === '/') {
            dispatch(NavSlice.actions.addSelectedKeys(['/dashboard/projectOverview'])) // 记住 menu 选中状态
        } else {
            dispatch(NavSlice.actions.addSelectedKeys([result2])) // 记住 menu 选中状态
        }
    }, [token])

    // useEffect(() => {
    //     const handleError = event => {
    //         if (event.error && event.error.name === 'ChunkLoadError') {
    //             // 尝试重新加载页面
    //             window.location.reload(true)
    //         }
    //     }
    //     window.addEventListener('error', handleError)
    //     // 清除函数，组件卸载时移除监听器
    //     return () => {
    //         window.removeEventListener('error', handleError)
    //     }
    // }, [])

    /* 获取系统信息 */
    useEffect(() => {
        if (ticket) return
        dispatch(getSystemInfoAction())
        if (token) dispatch(getAuthLocationDataAction())
    }, [])

    return (
        <ConfigProvider locale={language === 'en' ? en : zh}>
            {largeScreenURL || fvsListURL ? (
                largeScreenURL ? (
                    <MapLargeScreen />
                ) : (
                    <FVSList />
                )
            ) : ticket ? (
                <Relay />
            ) : token ? (
                <BrowserRouter>
                    <MainLayout>
                        {/* 路由 */}
                        <Routers />
                        {/* 边界错误处理 */}
                        <Boundary />
                    </MainLayout>
                </BrowserRouter>
            ) : (
                <Login />
            )}
        </ConfigProvider>
    )
}
